import { Draft, PayloadAction } from '@reduxjs/toolkit';
import formatters from 'formatters';

import { timelineTraderActions } from 'constants/intervention/timelineTraderActions';

import IGetDetailsClaimResponse from 'services/httpClient/responses/claim/IGetDetailsClaimResponse';
import IGetDetailsInterventionResponse from 'services/httpClient/responses/intervention/IGetDetailsInterventionResponse';

import { IInterventionData } from '../../initialState';

interface IGetDetailsInterventionsSuccessWithDataAction {
  claim: IGetDetailsClaimResponse;
  intervention: IGetDetailsInterventionResponse;
}

function getDetailsSuccess(
  draft: Draft<IInterventionData>,
  action: PayloadAction<IGetDetailsInterventionsSuccessWithDataAction>,
) {
  draft.getDetails.config.isLoading = false;
  draft.getDetails.claimInfo = {
    address: `${action.payload.claim.street_name} ${action.payload.claim.street_number},\n${action.payload.claim.zip_code} ${action.payload.claim.city}`,
    caseId: action.payload.claim.case_id,
    description: action.payload.claim.description,
    email: action.payload.claim.email,
    phone: action.payload.claim.phone,
    name: action.payload.claim.user_name,
    insurer: action.payload.claim.insurer,
    secondPhone: action.payload.claim.second_phone,
  };
  draft.getDetails.values = {
    availableActions: action.payload.intervention.available_actions,
    worker_ids: action.payload.intervention.worker_ids,
    category: action.payload.intervention.category,
    categoryFr: action.payload.intervention.category_fr,
    categoryId: action.payload.intervention.category_id,
    categoryNl: action.payload.intervention.category_nl,
    claimId: action.payload.intervention.claim_id,
    companyName: action.payload.intervention.companyname,
    email: action.payload.intervention.email,
    firstVisitDate: action.payload.intervention.first_visit_date,
    firstVisitDateUpdatedAt:
      action.payload.intervention.first_visit_date_updated_at,
    id: action.payload.intervention.id,
    interventionPartnershipId:
      action.payload.intervention.intervention_partnership_id,
    interventionType: action.payload.intervention.intervention_type,
    invoiceInsurerStatus: action.payload.intervention.invoice_insurer_status,
    invoiceNumber: action.payload.intervention.invoice_number,
    invoiceValueCents: action.payload.intervention.invoice_value_cents,
    mobilePhone: action.payload.intervention.mobile_phone,
    priceExclVat: action.payload.intervention.price_excl_vat,
    quoteApproved: action.payload.intervention.quote_approved,
    documentQuoteAddedAt: action.payload.intervention.document_quote_added_at
      ? formatters.date(action.payload.intervention.document_quote_added_at)
      : '--/--/----',
    quoteUpdatedAt: action.payload.intervention.quote_updated_at
      ? formatters.date(action.payload.intervention.quote_updated_at)
      : '--/--/----',
    notes: action.payload.intervention.notes.map(note => ({
      createdAt: formatters.date(note.created_at, { formatType: 'DD/MM/YYYY' }),
      wroteBy: note.wrote_by,
      id: note.id,
      text: note.text,
    })),
    quoteUpdatedBy: action.payload.intervention.quote_updated_by,
    quoteValueCents: action.payload.intervention.quote_value_cents,
    noRepair: action.payload.intervention.no_repair,
    repairDate: action.payload.intervention.repair_date,
    repairDateUpdatedAt: action.payload.intervention.repair_date_updated_at,
    repairEndDate: action.payload.intervention.repair_end_date,
    previousNonWhiteStatus:
      action.payload.intervention.previous_non_white_status,
    status: action.payload.intervention.status,
    traderId: action.payload.intervention.trader_id,
    traderName: action.payload.intervention.trader_name,
    vatPercentage: action.payload.intervention.vat_percentage,
    created_at: formatters.date(action.payload.intervention.created_at),
    timeline: timelineTraderActions.filter(timelineTraderAction =>
      timelineTraderAction.interventionType(
        action.payload.intervention.intervention_type,
      ),
    ),
  };
}

export default getDetailsSuccess;
